import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "../services/auth/auth.service";
import {LoggingService} from "../services/error-handling/logging.service";


export const teamsTokenGuard: CanActivateFn = (route, state) => {
  let authService = inject(AuthService);
  let loggingService = inject(LoggingService);

  loggingService.logInfo("AuthGuard - canActivate()")

  return new Promise((resolve) => {
    authService.getClientSideToken()
      .then(token => {
        if (token?.length > 0) {
          resolve(true)
        } else {
          resolve(false)
          authService.onAuthenticationFailed();
        }
      })
      .catch(() => {
        resolve(false);
        authService.onAuthenticationFailed();
      })
  });
};
